import classnames from 'classnames'
import { Component } from 'preact'
import { connectHierarchicalMenu } from 'react-instantsearch/connectors'
import Phrase from '../../../libs/translationsUtils/phrase'
import Icon from '../../assets'
import Count from './ResultsCount'

interface CategoryHit {
  label: string
  value: string
  items: CategoryHit[]
  count: number
  isRefined: boolean
}

interface Props {
  items: CategoryHit[]
  currentRefinement?: string
  defaultRefinement?: string
  refine: Function
  createURL: Function
  title?: string
  isChild?: boolean
}

interface State {
  isShowMoreBtn: boolean
}

export class HierarchicalMenu extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isShowMoreBtn: true
    }

    this.handleShowMore = this.handleShowMore.bind(this)
  }

  handleShowMore() {
    this.setState({
      isShowMoreBtn: !this.state.isShowMoreBtn
    })
  }

  render() {
    const { items, refine, createURL, title, isChild = false } = this.props
    const { isShowMoreBtn } = this.state
    return (
      <div className='instant-search__category-filter'>
        {title && <span className='instant-search__filter-title'>{title}</span>}

        {/* eslint-disable-next-line multiline-ternary */}
        {!items.length ? (
          <div class='instant-search__filter-no-results'>
            <Phrase p='No results' m='Control' />
          </div>
        ) : (
          <ul>
            {items.map((item, index) => (
              <li
                key={index}
                className={classnames('instant-search__filter-list-item', {
                  'instant-search__filter-list-item--hide': !isChild && isShowMoreBtn && index > 4
                })}
              >
                <div className='instant-search-filter__label-wrapper'>
                  <span
                    onClick={(event) => {
                      event.preventDefault()
                      refine(item.value)
                    }}
                    className={classnames({
                      refined: item.isRefined,
                      bold:
                        item.isRefined &&
                        (isChild ||
                          (item.items?.length > 1 &&
                            item.items?.filter((item) => item.isRefined).length === 0))
                    })}
                  >
                    {item.label}
                    <Count count={item.count} />
                    {(!isChild && !item.items && (
                      <Icon
                        size={20}
                        color='#6B707E'
                        icon='arrowDropdown'
                        customClass='instant-search-filter__closed'
                      />
                    )) ||
                      (!isChild && item.items && (
                        <Icon
                          size={20}
                          color='#6B707E'
                          icon='arrowDropUp'
                          customClass='instant-search-filter__open'
                        />
                      ))}
                  </span>
                </div>

                {Boolean(item.items) && (
                  <HierarchicalMenu
                    items={item.items}
                    refine={refine}
                    createURL={createURL}
                    isChild
                  />
                )}
              </li>
            ))}

            {isShowMoreBtn && items.length > 5 && !isChild && (
              <li
                className='instant-search__filter-list-item instant-search__filter-list-item--showMore'
                onClick={this.handleShowMore}
              >
                <Phrase m='Common' p='advanced.search.filter.show.more' />
              </li>
            )}
          </ul>
        )}
      </div>
    )
  }
}

const CustomHierarchicalMenu = connectHierarchicalMenu(HierarchicalMenu)

export default CustomHierarchicalMenu
